import F84Game from "./Game";
import InitialLoadUtils from "./utils/InitialLoadUtils";
import "phaser/plugins/spine/dist/SpinePlugin.js";

// Inject a DOM loader to show the user indeterminate progress while we wait for Phaser
//InitialLoadUtils.injectInitialLoader();

// Phaser requires DOMContentLoaded to function, we cannot enter it earlier than this
window.addEventListener("DOMContentLoaded", ():void=>{
    const canvas = document.createElement("canvas");
    canvas.style.position = "absolute";
    document.body.appendChild(canvas);
    const screenHeight = Math.min(window.screen.width, window.screen.height);
    const quality = screenHeight * window.devicePixelRatio < 768 ? 0.5 : 1;
    const canvasContext = <CanvasRenderingContext2D>(<unknown>canvas.getContext("webgl", {
        alpha: false,
        depth: true,
        antialias: false,
        premultipliedAlpha: true,
        stencil: true,
        preserveDrawingBuffer: false,
        failIfMajorPerformanceCaveat: false,
        powerPreference: "high-performance",
    }));
    (<any>window).game = new F84Game(canvas, canvasContext, quality);
});